import {createTooltipTranslationProviderFromNamespace} from 'features/localizedTooltips';

export const CompareVersionPanelTooltipTranslationProvider =
	createTooltipTranslationProviderFromNamespace(
		'features/RegDocs/compareVersionPanel',
	);
